import { useState } from "react";
import NewSearchPanel from "./NewSearchPanel";
import SourcingBatches from "./SourcingBatches";
import RipeningPanel from "./RipeningPanel";

export default function SourceView() {
  const [refresh, setRefresh] = useState(0);
  const [stats, setStats] = useState(null);
  // Source flow D: the panel's current stage + new batch id dim/highlight the list
  const [search, setSearch] = useState({ stage: 'configure', batchId: null });
  const [openRequest, setOpenRequest] = useState(null);
  const [rankStatus, setRankStatus] = useState(null);
  const token = localStorage.getItem('expertnet_token');

  return (
    <div style={{ padding: 24, maxWidth: 1440, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 600, letterSpacing: '-0.01em', color: 'var(--text-1)', margin: '0 0 4px' }}>Source</h1>
          <p style={{ fontSize: 13, color: 'var(--text-3)', margin: 0 }}>Plan a search, check counts, then fetch and rank leads.</p>
        </div>
        {stats && (
          <div style={{ display: 'flex', gap: 20, paddingBottom: 4 }}>
            {[
              { label: 'BATCHES', value: stats.batches, color: 'var(--text-1)' },
              { label: 'LEADS', value: stats.leads, color: 'var(--text-1)' },
              { label: 'KNOWN', value: stats.known, color: 'var(--accent)' },
            ].map(({ label, value, color }) => (
              <div key={label} style={{ textAlign: 'right' }}>
                <div className="r-eyebrow">{label}</div>
                <div style={{ fontFamily: 'var(--font-data)', fontSize: 20, fontWeight: 500, color }}>{value}</div>
              </div>
            ))}
          </div>
        )}
      </div>
      <NewSearchPanel
        token={token}
        onIngested={() => setRefresh(k => k + 1)}
        onStageChange={(stage, batchId) => setSearch({ stage, batchId })}
        onOpenBatch={(id, opts) => setOpenRequest(r => ({ id, n: (r?.n || 0) + 1, rank: !!opts?.rank }))}
        rankStatus={rankStatus}
      />
      <SourcingBatches
        project={null}
        token={token}
        refreshKey={refresh}
        onStats={setStats}
        dimmed={search.stage !== 'configure'}
        highlightId={search.stage === 'done' ? search.batchId : null}
        openRequest={openRequest}
        onRankStatus={setRankStatus}
      />
      <RipeningPanel token={token} />
    </div>
  );
}
